export default class QueryWhereAndOr
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryWhereAndOr";

	static And = "And";
	static Or = "Or";
		
	static labelOf(value)
	{
		if(value == "And")
			return "And";
		else if(value == "Or")
			return "Or";
		
		throw new Error("枚举错误");
	}
	
	static valueOf(value)
	{
		if(value == "And")
			return "And";
		else if(value == "Or")
			return "Or";
		
		throw new Error("枚举错误");
	}
	
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryWhereAndOr.js